import type { VideoTemplate } from "~/common/videoTemplate/types"

// 结果区空态展示的案例视频，按顺序取对应模板；模板下线时跳过
const EXAMPLE_TEMPLATE_IDS = [
  "SkyfallProduct",
  "BoardingPassSwitch",
  "LionChase",
]

export const getExampleVideos = (templates: VideoTemplate[]) =>
  EXAMPLE_TEMPLATE_IDS.flatMap((id) => {
    const template = templates.find((item) => item.templateId === id)
    return template ? [template] : []
  }).map((item, index) => ({
    label: `案例视频${index + 1}`,
    title: item.title,
    videoUrl: item.videoUrl,
  }))
